import ISLeads from './ISLeads';

export default ISLeads;
